import React from 'react';

export function PrivacyColoredIcon({ className, width = 30, height = 30 }) {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.625 3.75C7.48275 3.75 4.125 7.10775 4.125 11.25V18.75H7.125V11.25C7.125 8.76525 9.14025 6.75 11.625 6.75C14.1097 6.75 16.125 8.76525 16.125 11.25V18.75H19.125V11.25C19.125 7.10775 15.7673 3.75 11.625 3.75Z"
        fill="#C80E57"
      />
      <path
        d="M21.375 25.5C21.375 27.1567 20.0317 28.5 18.375 28.5H4.875C3.21825 28.5 1.875 27.1567 1.875 25.5V16.5C1.875 14.8432 3.21825 13.5 4.875 13.5H18.375C20.0317 13.5 21.375 14.8432 21.375 16.5V25.5Z"
        fill="#FFAC33"
      />
      <path
        d="M28.125 8.25C28.125 4.52175 25.1033 1.5 21.375 1.5C17.6467 1.5 14.625 4.52175 14.625 8.25C14.625 11.1877 16.5052 13.68 19.125 14.6077V26.625C19.125 27.6607 19.9643 28.5 21 28.5C21.9097 28.5 22.6673 27.852 22.8375 26.9925C22.851 26.9933 22.8615 27 22.875 27C23.2898 27 23.625 26.6647 23.625 26.25V25.5C23.625 25.0853 23.2898 24.75 22.875 24.75V24C23.2898 24 23.625 23.6647 23.625 23.25V21.75C23.625 21.3353 23.2898 21 22.875 21V19.2922C23.322 19.032 23.625 18.5543 23.625 18V14.6077C26.2448 13.6807 28.125 11.1885 28.125 8.25ZM21.375 3C22.203 3 22.875 3.672 22.875 4.5C22.875 5.328 22.203 6 21.375 6C20.547 6 19.875 5.328 19.875 4.5C19.875 3.672 20.547 3 21.375 3Z"
        fill="#C1694F"
      />
    </svg>
  );
}
